import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App.js'
import { msalInstance } from './authConfig.js'

// MSAL must be fully initialised before any React component touches it.
// handleRedirectPromise processes any redirect response coming back from
// the Microsoft login page (needed if loginRedirect is ever used as fallback).
msalInstance.initialize().then(async () => {
  // Process the auth response when Microsoft redirects back after login.
  // Returns null on a normal page load (no redirect in progress).
  try {
    const result = await msalInstance.handleRedirectPromise()
    if (result?.account) {
      msalInstance.setActiveAccount(result.account)
    }
  } catch (e) {
    console.error('MSAL redirect error:', e)
  }

  const root = ReactDOM.createRoot(document.getElementById('root'))
  root.render(<App />)
})
